import React from "react";
import { observer } from "mobx-react";

import { BettingTips } from "@api-types/bet-booster/BettingTipsType";

import { formatTip, formatType } from "@utils/common/bettingTipsUtils";
import { QuickPlayPopupsTeams } from "@features/quick-play/mobile/common/QuickPlayPopupsTeams";
import { QuickPlayEventTime } from "@features/quick-play/mobile/common/QuickPlayEventTime";

export default observer(function BettingTipsPopupBody(props: {
	tip: BettingTips;
	isEventLinkDisabled?: boolean;
}) {
	return (
		<div className="card--bbp">
			<div className="card--qp__body card--bbp__body u-padd--reset">
				<div className="card--bbt__header u-mar--bottom--tny">
					<div className="card--bbt__description">
						{props.tip?.description}
					</div>
				</div>

				<div className="card--qp__event card--mpt__event">
					<QuickPlayEventTime
						startTime={props.tip.sportData.startTime}
						sportAbrv={props.tip.sportData.sportAbrv}
					/>
				</div>
				<div className="card--qp__event card--bbp__event">
					<QuickPlayPopupsTeams
						sportData={props.tip.sportData}
						eventId={props.tip.eventId}
						isLinkDisabled={props.isEventLinkDisabled}
					/>
				</div>

				<div className="card--qp__offer card--mpt__offer">
					<div className="card--qp__item card--mpt__item">
						<div className="card--qp__market card--bbp__market">
							<div className="card--qp__type card--bbp__type">
								{formatType(props.tip)}
							</div>
							:
							<div className="card--qp__tip card--bbp__tip">
								{formatTip(props.tip)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
});
